export default {
    REGISTER_REQUIRED: 'REGISTER_REQUIRED',
    REGISTER_REQUEST: 'REGISTER_REQUEST',
    REGISTER_ERROR: 'REGISTER_ERROR',
    CLEAR_REGISTER_ERROR: 'CLEAR_REGISTER_ERROR',
    REGISTER_SUCCESS: 'REGISTER_SUCCESS',
};